export default __webpack_public_path__ + "static/media/ivana-squares.3c555b85.jpg";